import {
  StyleSheet,
  SafeAreaView,
  ImageBackground,
  Image,
  useWindowDimensions,
} from "react-native";
import React, { useEffect, useState } from "react";
import {
  Box,
  ScrollView,
  View,
  Pressable,
  Text,
  HStack,
  Flex,
} from "native-base";
import { StackScreenProps } from "../../types";
import Header from "../../components/Header";
import CountUp from "react-countup";
import AsyncStorage from "@react-native-async-storage/async-storage";

const FFH = ({ navigation }: StackScreenProps<"ResearchAndDev">) => {
  const { width, height } = useWindowDimensions();

  const [data, setData] = useState({});
  useEffect(() => {
    async function getData() {
      const items = await AsyncStorage.getItem("keyFigures");

      if (items) {
        try {
          setData(JSON.parse(items));
          // console.log(JSON.parse(items));
        } catch (error) {
          console.log(error);
        }
      }
    }

    getData();
  }, []);

  const objectives = [
    require("../../assets/objectives/objectives1.png"),
    require("../../assets/objectives/objectives2.png"),
    require("../../assets/objectives/objectives3.png"),
    require("../../assets/objectives/objectives4.png"),
    require("../../assets/objectives/objectives5.png"),
    require("../../assets/objectives/objectives6.png"),
    require("../../assets/objectives/objectives7.png"),
    require("../../assets/objectives/objectives8.png"),
    require("../../assets/objectives/objectives9.png"),
    require("../../assets/objectives/objectives10.png"),
    require("../../assets/objectives/objectives11.png"),
    require("../../assets/objectives/objectives12.png"),
  ];

  type Section = {
    title: string;
    content: string[];
    index: number;
  };
  const SECTIONS = [
    {
      title: "Farm and Fortune Hub Value Additions",
      content: [
        "- Smallholder farmers Reach",
        "- Access to quality farm inputs",
        "- Job creation",
        "- Training on Good Agricultural Practices (GAP)",
        "- Financial literacy training and Inclusion ",
        "- Demo plots & Greenhouses",
        "- Digital Technology",
        "- Produce Storage and Offtake Hub",
        "- Soil analysis and Fertilizer recommendations ",
        "- Mechanization and Irrigation services",
        "- Access to clean water",
        "- Redistribution with the use of tricycle",
        "- Specialized fertilizers",
      ],
      index: 0,
    },
  ];

  const renderContent = (section: Section) => {
    return (
      <View style={styles.content}>
        {section.content.map((item) => (
          <Text key={item} fontWeight={"bold"} mb={1}>
            {item}
          </Text>
        ))}
      </View>
    );
  };

  return (
    <ImageBackground
      source={require("../../assets/ffh_bg.png")}
      resizeMode="cover"
      style={{ width, height }}
    >
      <View style={styles.overlay}>
        <SafeAreaView style={{ height }}>
          <ScrollView>
            <View px={10} justifyContent="center" mb={5}>
              <Header
                onPress={() => navigation.navigate("Distribution")}
                parentText="Last-Mile Distribution"
                headingText="Farm and Fortune Hub (FFH)"
              />
              <Text mb={5} textAlign="center" fontWeight={"bold"}>
                Key figures:
              </Text>

              <Box
                width={"full"}
                // h="16"
                mb={5}
                margin="auto"
                // borderBottomColor="#000"
                borderColor={"#ccc"}
                borderWidth="1"
                borderRadius={15}
                p={5}
                pb={2}
              >
                <HStack justifyContent={"space-between"}>
                  <View>
                    <Text fontWeight={"extrabold"} fontSize="2xl">
                      <CountUp delay={0} end={data["ffh_1"]} />
                    </Text>
                    <Text fontWeight={"bold"}>Hubs</Text>
                  </View>
                  <View>
                    <Text fontWeight={"extrabold"} fontSize="2xl">
                      <CountUp
                        delay={0}
                        end={data["ffh_2"] / 1000}
                        suffix=",000+"
                      />
                    </Text>
                    <Text fontWeight={"bold"}>Farmers Reached</Text>
                  </View>
                  <View>
                    <Text fontWeight={"extrabold"} fontSize="2xl">
                      <CountUp delay={0} end={data["ffh_3"]} suffix="+" />
                    </Text>
                    <Text fontWeight={"bold"}>Jobs Created</Text>
                  </View>
                </HStack>
              </Box>

              <Text textAlign="center" mb={5} fontSize="xs">
                This project will not just secure significant goodwill from
                Nigeria government but will utilize gas from Nigeria and
                Phosphate from Morocco to make Nigeria self-sufficient in
                fertilizer production. This industrial plant will serve as
                source of Nitrogen to Morocco & Phosphate to Nigeria and share
                resources between both countries to make Nigeria the preferred
                source of phosphate-based fertilizer to west Africa neighbors.
              </Text>
            </View>

            <Pressable
              bg="#01CD51"
              borderRadius={15}
              p={1}
              w={220}
              margin="auto"
              style={styles.buttonShadow}
              mb={10}
              onPress={() => navigation.navigate("HubMap")}
            >
              <Text textAlign={"center"}>Locate Hubs across Nigeria</Text>
            </Pressable>

            <Text
              px={10}
              fontWeight={"bold"}
              pl={4}
              mb={5}
              textAlign={"center"}
            >
              Farm And Fortune Hub Value Additions
            </Text>

            {/* <View
              style={{
                backgroundColor: "rgba(0,0,0,.2)",
                borderRadius: 20,
                // marginHorizontal: 15,
                width: "100%",
                alignSelf: "center",
                marginBottom: 10,
                borderWidth: 1,
                borderColor: "rgba(0,0,0,.2)",
              }}
            >
              {renderContent(SECTIONS[0])}
            </View> */}

            {/* <Text fontWeight={"bold"} textAlign="center" mt={10} mb={5}>
              Objectives of the Farm and Fortune Hub{" "}
            </Text> */}

            <Flex
              direction="row"
              flexWrap={"wrap"}
              justifyContent="space-between"
              px={3}
            >
              {objectives.map((item, i) => (
                <ImageBackground
                  key={i}
                  source={item}
                  resizeMode="contain"
                  style={{
                    width: 170,
                    height: 200,
                    // marginRight: 10,
                    marginBottom: 10,
                  }}
                />
              ))}
            </Flex>
          </ScrollView>
        </SafeAreaView>
      </View>
    </ImageBackground>
  );
};

export default FFH;

const styles = StyleSheet.create({
  overlay: {
    ...StyleSheet.absoluteFillObject,
    backgroundColor: "#015c1ce0",
  },
  cardOverlay: {
    ...StyleSheet.absoluteFillObject,
    backgroundColor: "rgba(0, 0, 0, 0.1)",
  },
  buttonShadow: {
    shadowOffset: { width: 0, height: 2 },
    shadowRadius: 1,
    shadowOpacity: 0.3,
    shadowColor: "#000000",
    elevation: 5,
  },
  header: {
    backgroundColor: "rgba(0,0,0,.2)",
    padding: 10,
    borderRadius: 20,
    // marginBottom: 20,
  },
  headerText: {
    textAlign: "center",
    fontSize: 16,
    fontWeight: "500",
  },
  content: {
    padding: 20,
    backgroundColor: "transparent",
    borderRadius: 20,
  },
  active: {
    backgroundColor: "rgba(255,255,255,1)",
  },
});
